import { cn } from "@/lib/utils";
import { Expert } from "@/types/types";
import { DisplayAvatar, DisplayAvatarProps } from "../display/DisplayAvatar";

type ExpertAvatarProps = Pick<DisplayAvatarProps, "size"> & {
  expert: Pick<Expert, "name" | "profilePicture">;
  invertColors?: boolean;
  className?: string;
};

const DEFAULT_EXPERT_BACKGROUND_COLOR = "bg-foreground-5";

export const ExpertAvatar = ({
  expert,
  size,
  className,
  invertColors = false,
}: ExpertAvatarProps) => {
  return (
    <DisplayAvatar
      text={expert.name}
      picture={expert.profilePicture}
      size={size}
      className={cn(
        {
          [DEFAULT_EXPERT_BACKGROUND_COLOR]: !invertColors,
          "bg-white": invertColors,
          ["text-white"]: !invertColors,
          ["text-foreground"]: invertColors,
        },
        className,
      )}
    />
  );
};
